import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import PropTypes from "prop-types";

const useStyles = makeStyles(() => ({
  chip: {
	borderColor: "#780F9E",
	color: "#780F9E",
	transition: "background-color 0.2s ease, color 0.2s ease",
	"&:hover": {
	  backgroundColor: "#780F9E !important",
	  color: "#FFF",
	},
	"&:focus, &:active": {
	  backgroundColor: "#780F9E !important",
	  color: "#FFF",
	},
  },
  selectedChip: {
	backgroundColor: "#780F9E !important",
	color: "#FFF",
	"&:hover, &:focus, &:active": {
	  backgroundColor: "#5E0C7A !important",
	  color: "#FFF",
	},
  },
}));

const ToggleChips = ({ chipData, subFilters, setSubFilters }) => {
  const classes = useStyles();

  // Determines if a chip should be selected based on subFilters
  const isChipSelected = (chipFilter) => {
	if (!chipFilter) return false;
  
	for (const key in chipFilter) {
	  const chipValue = chipFilter[key];
	  const subFilterValue = subFilters[key];
  
	  if (chipValue === null) {
		if (key in subFilters) return false; // If chip requires absence, but it's present, not selected
	  } else if (Array.isArray(chipValue)) {
		if (!Array.isArray(subFilterValue) || chipValue.length !== subFilterValue.length || 
			!chipValue.every((val) => subFilterValue.includes(val))) {
		  return false; // Ensures array values match (ignoring order)
		}
	  } else if (subFilterValue !== chipValue) {
		return false; // If it's a primitive value, ensure exact match
	  }
	}
	return true;
  };
  
  

  const handleToggle = (chipKey) => {
	let newFilters = { ...subFilters };
	const chip = chipData.find((c) => c.key === chipKey);
  
	if (!chip) return;
  
	if (isChipSelected(chip.filter)) {
	  // Remove only the matching key-value pairs from subFilters
	  
	  Object.keys(chip.filter).forEach((key) => {
		if (newFilters[key] === chip.filter[key]) {
		  delete newFilters[key];
		}
	  });
	} else {
	  Object.assign(newFilters, chip.filter);
	}
	console.log(chip, newFilters);
	setSubFilters(newFilters, true);
  };
  

  return (
	<div
	  style={{
		padding: 16,
		display: "flex",
		gap: 8,
		flexWrap: "wrap",
		alignItems: "center",
	  }}
	>
	  <strong>Shortcuts: </strong>
	  {chipData.map((chip) => (
		<Chip
		  key={chip.key}
		  label={chip.label}
		  onClick={() => handleToggle(chip.key)}
		  onMouseDown={(e) => e.preventDefault()} // Prevents unwanted focus styling
		  className={isChipSelected(chip.filter) ? classes.selectedChip : classes.chip}
		  data-selected={isChipSelected(chip.filter) ? "true" : undefined}
		  variant="outlined"
		/>
	  ))}
	</div>
  );
};

ToggleChips.propTypes = {
  chipData: PropTypes.arrayOf(
	PropTypes.shape({
	  key: PropTypes.number.isRequired,
	  label: PropTypes.string.isRequired,
	  filter: PropTypes.object, // Each chip has an object filter
	})
  ).isRequired,
  subFilters: PropTypes.object.isRequired, // Key-value object for selected filters
  setSubFilters: PropTypes.func.isRequired, // Function to update selected filters
};

export default ToggleChips;
